import React from 'react';

export default function ContractDetails({ contracts }) {
    if (!contracts || contracts.length === 0) {
        return null;
    }

    return (
        <div className="generic-details__block contract-details">

            <div className="details-row details-row--header">
                <div className="details-col">
                    <p className="details-label">Contract end date</p>
                </div>
                <div className="details-col">
                    <p className="details-label">Expected billing date</p>
                </div>
                <div className="details-col">
                    <p className="details-label">Payment method</p>
                </div>
                <div className="details-col">
                    <p className="details-label">Billing term</p>
                </div>
            </div>

            {contracts.map((contract, index) => (
                <div className="details-row" key={contract.id || index}>
                    <div className="details-col">
                        <strong>{contract.contractEndDate}</strong>
                    </div>
                    <div className="details-col">
                        <strong>{contract.billingDate}</strong>
                    </div>
                    <div className="details-col">
                        <strong>{contract.paymentMethod}</strong>
                    </div>
                    <div className="details-col">
                        <strong>{contract.billingTerm}</strong>
                    </div>
                </div>
            ))}

        </div>
    );
}